import { render, staticRenderFns } from "./RuleReview.vue?vue&type=template&id=dee7204c&"
import script from "./RuleReview.vue?vue&type=script&lang=js&"
export * from "./RuleReview.vue?vue&type=script&lang=js&"
import style0 from "./RuleReview.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RuleReview.vue"
export default component.exports